// extracted by mini-css-extract-plugin
export default {"formHeader":"Signup_formHeader__EH-ea","formBoldText":"Signup_formBoldText__-K5in"};